import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminService } from '../services/admin.service';
import { AuthService } from '../services/auth.service';
import { ROUTES } from '../shared/constants';

export const forgotPasswordGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const adminService = inject(AdminService);

  const isAdminRoute = state.url.includes('/admin');
  const service = isAdminRoute ? adminService : authService;
  const redirectUrl = isAdminRoute ? ROUTES.ADMIN.DASHBOARD : ROUTES.USER.LOGIN;

  if (service.accessToken) {
    await router.navigate([redirectUrl]);
    return false;
  }

  return true;
};
